/* eslint-disable complexity */
import React, { useState, useEffect, useContext, useMemo, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { UserOrderContext } from 'context/context';
import { useSelector, useDispatch } from 'react-redux';
import {
  isEmptyObject,
  isEmptyEvery,
  isMobileDevice,
  ParseJsonSafely,
  getValueOrDefaultObject,
} from 'common/utilities/utils';
import { recommendedProductAction } from '@kfc-global/react-shared/redux/Actions/MenuAction';
import { showCustomizationModalAction } from '@kfc-global/react-shared/redux/Actions/CartAction';
import getSpecialEventItemAvailabilityAction from '@kfc-global/react-shared/redux/Actions/SpecialEventAction';
import { CHRISTMAS_ORDERING } from 'common/constants/SharedConstants';
import {
  DIETARY,
  FILTER_BY,
  MENU_PLP_CONSTANT,
  SORRY,
  CURRENTLY_CLOSED,
  CC_MESSAGE,
  KEEP_BROWSING,
  FIND_OPEN_KFC,
  INDIA,
} from '../MenuPLPConstants/MenuPLPConstants';
import ProductListingModalOptions from 'organisms/ProductListingModalOptions/Container/ProductListingModalOptionsComponent';
import { setAnalyticsDataFilter, setAnalyticsDataSearchPlp, checkItemName } from '../MenusPlpUtilities/MenusPlpUtils';
import ProductState from '../Presentation/ProductState';
import { toast } from 'react-toastify';
import { HIDE_COPY_COUPON_ACTION } from 'organisms/DealsAndOffersLanding/constants/offersAndDealsConstants';
import { getList } from 'organisms/ScheduleOrder/ScheduleOrderUtils/ScheduleOrderUtils';
import { CompactMenuItem } from '../Presentation/CompactMenu';
import CustomizationAlert from 'organisms/CustomizationAlert/Container/CustomizationAlertContainer';
import { getDispositionNewData } from 'organisms/MenusPLP/MenusPlpUtilities/MenuPLPSharedUtils';
import { getEpochTime } from 'common/utilities/dayJsUtils';
import DayJsUtil from '@kfc-global/react-shared/utils/DayJSUtils';
import isEmpty from 'lodash/isEmpty';

const tenantReducerFilter = [
  {
    filterBy: ['exclusive', 'topseller', 'newitem'],
    dietry: ['all', 'veg'],
  },
];

const sortByOpts = [
  { name: 'New', selected: false },
  { name: 'Bestsellers', selected: false },
  { name: 'Best Value', selected: false },
];

export const getBooleanValue = (propertyVal, filterVal) => {
  let value = propertyVal === 'true' ? true : false;
  return value === filterVal;
};

export const storeCloseFun = (
  isStorePeriodsUnavaialable,
  availabeSlots,
  storeStatus,
  { setIsStoreClosed, setIsStoreNone, setIsModalOpen },
) => {
  if ((storeStatus === 'CLOSED' || isStorePeriodsUnavaialable) && !availabeSlots.length) {
    setIsStoreClosed(true);
    setIsStoreNone(false);
    setIsModalOpen(true);
  } else {
    setIsStoreClosed(false);
    setIsStoreNone(false);
    setIsModalOpen(false);
  }
};

export const getScElmnt = (currentStoreName, storeInfo, soHandler, closeModal) => {
  return (
    <>
      <h1>
        {SORRY}, {currentStoreName} {CURRENTLY_CLOSED}
      </h1>
      <p>{CC_MESSAGE}</p>
      <div className='d-flex justify-content-center action-buttons'>
        <button
          type='button'
          className={'btn btn-light mr-3'}
          data-dismiss='modal'
          data-testid={'close-modal-id'}
          onClick={() => closeModal()}
        >
          {KEEP_BROWSING}
        </button>
        <button
          type='button'
          className={'btn btn-dark ml-3'}
          data-dismiss='modal'
          data-testid={'schedule-order-btn'}
          onClick={e => soHandler(e, storeInfo)}
        >
          {FIND_OPEN_KFC}
        </button>
      </div>
    </>
  );
};

export const initialFilters = (filtersData, type) => {
  let filterArr = [];
  filtersData.forEach(obj => {
    let filterables = obj[type];
    filterables.forEach(item => {
      let filterObj = {
        name: item,
        checked: false,
      };
      filterArr.push(filterObj);
    });
  });
  return filterArr;
};

export const filterByKeyValues = (tempData, key, value, type = 'equals') => {
  let productArr = [];
  let filteredObj = tempData.categories
    .filter(({ isHidden }) => !isHidden)
    .map(obj => {
      // default will be equals
      let obj1 = obj.products.filter(objN => !objN.isHidden && objN[key] === value);
      if (type === 'exists') {
        if (key === 'name') {
          obj1 = obj.products.filter(
            objN =>
              (!objN.isHidden && objN[key].toLowerCase().indexOf(value) !== -1) ||
              checkItemName(objN?.dname?.[0]?.value, value),
          );
        } else {
          obj1 = obj.products.filter(
            objN => !objN.isHidden && objN?.dname?.[0]?.value.toLowerCase().indexOf(value) !== -1,
          );
        }
      }
      if (obj1?.length) {
        obj.products = obj1;
        /**
         * RENDEV-14999 Menu search result show all products
         */
        productArr.push(obj1);
        return obj;
      }
      return false;
    })
    .filter(Boolean);
  return {
    productArr,
    filteredObj,
  };
};
const filterFromProducts = (products, filterOption) => {
  return products.filter(product =>
    product.items.find(obj =>
      obj.additionalProperties.find(property => {
        return (
          property.key === filterOption.name && getBooleanValue(property.value.toLowerCase(), filterOption.checked)
        );
      }),
    ),
  );
};
const filterFromExistingProductArray = (prodArr, filterOption) => {
  return prodArr
    .flat()
    .filter(product =>
      product.items.find(obj =>
        obj.additionalProperties.find(
          property =>
            property.key === filterOption.name && getBooleanValue(property.value.toLowerCase(), filterOption.checked),
        ),
      ),
    );
};

export const applyFilterForFilterBy = (arr, productArr, products) => {
  if (arr.length > 0) {
    arr.forEach((filterOption, index) => {
      if (productArr.length === 0) {
        let prod = filterFromProducts(products, filterOption);
        prod.length > 0 && productArr.push(prod);
      } else {
        let filteredArray = filterFromExistingProductArray(products, filterOption);
        productArr[0].push(...filteredArray);
      }
    });
    return productArr;
  } else {
    return [];
  }
};

export const applyFilterForDietary = (arr, productArr, products, tempData) => {
  if (arr) {
    arr.forEach((filterOption, index) => {
      if (productArr.length === 0) {
        if (filterOption.name === 'all') {
          productArr.push(tempData.products);
        } else {
          let prod = filterFromProducts(products, filterOption);
          prod.length > 0 && productArr.push(prod);
        }
      } else {
        if (filterOption.name === 'all') {
          return null;
        } else {
          productArr = filterFromExistingProductArray(productArr, filterOption);
        }
      }
    });
  }
  return productArr;
};

export const checkAvailablity = (from, to, initialInterval, asap, futureDates, tenantReducer, unavailibilities) => {
  return getList(
    from,
    to,
    initialInterval,
    asap?.isAvailable,
    futureDates?.length === 1 && tenantReducer?.country?.toUpperCase() === INDIA,
    unavailibilities,
  );
};

export const MenusPlpComponent = props => {
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const { contentData: navigationContentData, selectedCat } = props;
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { selectedTile, storeInfo, dispositionType, tenantReducer } = navigationContentData;
  const { SERVICE_CHANNEL } = MENU_PLP_CONSTANT;
  const dispatch = useDispatch();
  const catalogs =
    (storeInfo?.summary?.menu?.catalogs?.length && storeInfo.summary.menu.catalogs[0]) ||
    tenantReducer?.genericMenuName ||
    '';
  const storeId = storeInfo?.id;
  const serviceType = dispositionType;
  const location = useLocation();

  const cartReducer = useSelector(data => data.cartReducer);
  const menuReducer = useSelector(data => data.menuReducer);
  const specialEventReducer = useSelector(data => data.specialEventReducer);

  const dispositionNew = getDispositionNewData(userOrderState);
  const specialEventItemAvailability = useMemo(
    () => specialEventReducer?.specialEventItemAvailability || [],
    [specialEventReducer?.specialEventItemAvailability],
  );
  const isLoadingSpecialEvent = specialEventReducer?.isLoading || false;

  const prodsData = getValueOrDefaultObject(menuReducer?.data);
  const flatResponse = getValueOrDefaultObject(menuReducer.flatResponse);
  const recommendedProds = getValueOrDefaultObject(menuReducer.recommendedProducts);

  const [filteredData, setfilteredData] = useState([]);
  const [filterList, setFilterList] = useState([]);
  const [dietaryList, setDietaryList] = useState([]);
  const [sortByList, setSortByList] = useState([]);
  const [filteredArr, setFilteredArr] = useState([]);
  const [dietaryArr, setDietaryArr] = useState([]);
  const [filterOptions, setFilterOptions] = useState(initialFilters(tenantReducerFilter, 'filterBy'));
  const [dietaryOptions, setDietaryOptions] = useState(initialFilters(tenantReducerFilter, 'dietry'));
  const [sortByOptions, setSortByOptions] = useState(sortByOpts);
  const [isStoreClosed, setIsStoreClosed] = useState(false);
  const [isStoreNone, setIsStoreNone] = useState(false);
  const [storeName, setStoreName] = useState('STORE');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchMode, setSearchMode] = useState('');
  const [productId, setProductId] = useState('');

  const storeInfoData = useMemo(() => {
    return isEmptyEvery(userOrderState.currentStoreInfo)
      ? ParseJsonSafely(localStorage.getItem('currentStoreInfo'))
      : userOrderState.currentStoreInfo;
  }, [userOrderState.currentStoreInfo]);

  const { futureDates, scheduled: initiallyScheduled, asap } = getValueOrDefaultObject(storeInfoData?.summary?.timings);
  const { unavailibilities } = getValueOrDefaultObject(initiallyScheduled);
  const { interval: initialInterval = 0, startEndTime = {} } = getValueOrDefaultObject(
    initiallyScheduled?.periods?.length && initiallyScheduled?.periods[0],
  );
  const { from, to } = startEndTime;

  const updateStoreStatus = useCallback(() => {
    if (isEmptyObject(storeInfoData)) {
      let storeStatus = storeInfoData.summary?.status?.currentStatus;
      let currStoreName = storeInfoData.summary?.name;
      let isStorePeriodsUnavaialable = storeInfoData.summary?.timings?.scheduled?.periods?.length === 0;
      let availabeSlots = checkAvailablity(
        from,
        to,
        initialInterval,
        asap,
        futureDates,
        tenantReducer,
        unavailibilities,
      );
      setStoreName(currStoreName);
      storeCloseFun(isStorePeriodsUnavaialable, availabeSlots, storeStatus, {
        setIsStoreClosed,
        setIsStoreNone,
        setIsModalOpen,
      });
    } else {
      setIsStoreClosed(false);
      setIsStoreNone(false);
      setIsModalOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeInfoData]);

  useEffect(() => {
    updateStoreStatus();
  }, [updateStoreStatus]);

  useEffect(() => {
    if (dispositionType === CHRISTMAS_ORDERING && !isLoadingSpecialEvent && isEmpty(specialEventItemAvailability)) {
      const selectedTime = DayJsUtil.formatValue(
        DayJsUtil.dayjs(dispositionNew?.selectedTime, tenantReducer?.timeFormat),
        tenantReducer?.itemAvailabilityTime,
      );
      const selectedDayEpochFormat = getEpochTime(
        dispositionNew?.date + ' ' + dispositionNew?.selectedTime,
        'YYYY-MM-DD h:mm A',
      );
      dispatch(getSpecialEventItemAvailabilityAction(storeId, selectedDayEpochFormat, selectedTime));
    }
  }, [
    dispatch,
    dispositionNew?.date,
    dispositionNew?.selectedTime,
    dispositionType,
    isLoadingSpecialEvent,
    specialEventItemAvailability,
    storeId,
    tenantReducer?.itemAvailabilityTime,
    tenantReducer?.timeFormat,
  ]);

  useEffect(() => {
    const { coupons = {} } = tenantReducer?.componentOptions || {};
    const { showCouponCopied = false, couponCopiedMessage = 'Coupon Copied' } = coupons;
    if (showCouponCopied && userOrderState?.showCouponCopied) {
      toast.dark(
        <div className='img-text-div' data-testid='toast-msg'>
          <span className='text'>{couponCopiedMessage}</span>
        </div>,
        {
          className: 'copied-toast-position',
          bodyClassName: 'success-copied-toast',
          hideProgressBar: true,
          position: toast.POSITION.BOTTOM_CENTER,
        },
      );
      setTimeout(() => {
        toast.dismiss();
        userOrderStateDispatch({ type: HIDE_COPY_COUPON_ACTION });
      }, 4000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const applyFilterOptionsOnData = arr => {
    let tempData = JSON.parse(JSON.stringify(prodsData));
    let products = [...tempData.products];
    let productArr = [];
    let allSelected = arr.find(({ name }) => name === 'all');
    if (allSelected) {
      productArr.push(tempData.products);
    } else {
      let filterArr = arr.filter(({ flag }) => flag === FILTER_BY);
      let dietaryArray = arr.filter(({ flag }) => flag === DIETARY);
      let filterReturnArr = applyFilterForFilterBy(filterArr, productArr, products);
      productArr = applyFilterForDietary(dietaryArray, filterReturnArr, products, tempData);
    }
    let tempFilteredData;
    if (arr.length === 0) {
      tempFilteredData = { ...tempData };
    } else {
      tempFilteredData = {
        ...tempData,
        menu: [],
        categories: [],
        products: productArr.flat(),
      };
    }
    setfilteredData(tempFilteredData);
  };

  const handleCheckbox = (e, buttonName) => {
    if (!isMobileDevice(window.innerWidth)) {
      // analytics event triggered
      setAnalyticsDataFilter(
        {
          eventType: 'filterItems',
          selectedData: {
            filterSelected: buttonName === FILTER_BY ? e.target.value : '',
            dietarySelected: buttonName === DIETARY ? e.target.value : '',
            sortSelected: '',
          },
        },
        'filterSelected',
        'dietarySelected',
        'sortSelected',
      );
    }
    if (buttonName === FILTER_BY) {
      let arr = [...filterOptions].map(item => {
        if (item.name === e.target.value) {
          if (!item.checked) {
            let temp = [...filterList];
            temp.push(e.target.value);
            setFilterList(temp);
          } else {
            let temp = [...filterList];
            temp.splice(filterList.indexOf(e.target.value), 1);
            setFilterList(temp);
          }
          return { ...item, checked: !item.checked, flag: FILTER_BY };
        } else {
          return { ...item };
        }
      });
      let filteredArrayData = arr.filter(obj => obj.checked);
      applyFilterOptionsOnData([...dietaryArr, ...filteredArrayData]);
      setFilteredArr(filteredArrayData);
      setFilterOptions(arr);
    } else if (buttonName === DIETARY) {
      let arr = [...dietaryOptions].map(item => {
        if (item.name === e.target.value) {
          if (!item.checked) {
            let temp = [...dietaryList];
            temp.push(e.target.value);
            setDietaryList(temp);
          } else {
            let temp = [...dietaryList];
            temp.splice(dietaryList.indexOf(e.target.value), 1);
            setDietaryList(temp);
          }
          return { ...item, checked: !item.checked, flag: DIETARY };
        } else {
          return { ...item };
        }
      });
      /*here for dietary filter */
      let dietaryArrayData = arr.filter(obj => obj.checked);
      applyFilterOptionsOnData([...filteredArr, ...dietaryArrayData]);
      setDietaryArr(dietaryArrayData);
      setDietaryOptions(arr);
    }
  };

  const handleRadio = e => {
    if (!isMobileDevice(window.innerWidth)) {
      // analytics tagging
      setAnalyticsDataFilter(
        {
          eventType: 'filterItems',
          selectedData: { filterSelected: '', dietarySelected: '', sortSelected: e.target.value },
        },
        'filterSelected',
        'dietarySelected',
        'sortSelected',
      );
    }
    let arr = [...sortByOptions].map(item => {
      if (item.name === e.target.value) {
        return { ...item, selected: !item.selected };
      }
      return { ...item, selected: false };
    });
    setSortByList([arr.find(item => item.selected).name]);
    setSortByOptions(arr);
  };

  const handleFilteredData = mdmId => {
    let tempData = JSON.parse(JSON.stringify(prodsData));
    let { productArr, filteredObj } = filterByKeyValues(tempData, 'mdmId', mdmId, 'equals');
    const tempFilteredData = Object.assign(tempData, {
      menu: [],
      categories: filteredObj,
      products: productArr.flat(),
    });
    setfilteredData(tempFilteredData);
  };

  const handleSearchdata = name => {
    if (name) {
      let tempData = JSON.parse(JSON.stringify(prodsData));
      let { productArr, filteredObj } = filterByKeyValues(tempData, 'name', name, 'exists');
      const tempFilteredData = Object.assign(tempData, {
        menu: [],
        categories: filteredObj,
        products: productArr.flat(),
      });
      setfilteredData(tempFilteredData);
      // analytics event triggered
      setAnalyticsDataSearchPlp(
        {
          eventType: 'userSearch',
          selectedData: { searchTerm: name, resultsFound: productArr.flat().length },
        },
        'searchTerm',
        'resultsFound',
      );
    } else {
      setfilteredData({});
    }
  };

  const handleClearItems = removedItemName => {
    let flag = '';
    if (typeof removedItemName === 'string') {
      // we are expecting only 2 types of date, either string or an event
      // Checking Dietary part
      let arr = [...dietaryOptions].map(item => {
        if (removedItemName === item.name) {
          flag = 'dietary';
          return { ...item, checked: false };
        } else {
          return { ...item };
        }
      });
      if (flag === 'dietary') {
        let dietaryArrayData = arr.filter(obj => obj.checked);
        console.log([...filteredArr, ...dietaryArrayData]);
        applyFilterOptionsOnData([...filteredArr, ...dietaryArrayData]);
        setDietaryArr(dietaryArrayData);
        setDietaryOptions(arr);
        let temp = [...dietaryList];
        temp.splice(dietaryList.indexOf(removedItemName), 1);
        setDietaryList(temp);
      }

      // Checking Filter By part
      let arr2 = [...filterOptions].map(item => {
        if (removedItemName === item.name) {
          flag = 'filter';
          return { ...item, checked: false };
        } else {
          return { ...item };
        }
      });
      if (flag === 'filter') {
        let filteredArrayData = arr2.filter(obj => obj.checked);
        applyFilterOptionsOnData([...dietaryArr, ...filteredArrayData]);
        setFilteredArr(filteredArrayData);
        setFilterOptions(arr2);
        let temp2 = [...filterList];
        temp2.splice(filterList.indexOf(removedItemName), 1);
        setFilterList(temp2);
      }
      if (flag === '') {
        setSortByOptions(
          sortByOptions.map(item => {
            return { ...item, selected: false };
          }),
        );
        setSortByList([]);
      }
    } else {
      let arr = [...dietaryOptions].map(item => {
        return { ...item, checked: false };
      });
      setDietaryOptions(arr);
      let temp = [...filterOptions].map(item => {
        return { ...item, checked: false };
      });
      setFilterOptions(temp);
      setSortByOptions(
        sortByOptions.map(item => {
          return { ...item, selected: false };
        }),
      );
      applyFilterOptionsOnData([]);
      setFilterList([]);
      setDietaryList([]);
      setSortByList([]);
      setFilteredArr([]);
      setDietaryArr([]);
    }
  };

  const getRecommends = search_data => {
    setSearchMode(search_data);
  };

  useEffect(() => {
    if (cartReducer.showProductListingModal) {
      dispatch(
        showCustomizationModalAction({
          showProductListingModal: false,
          categorySelected: '',
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    //dispatch menu and recommendations api actions
    if (catalogs && serviceType && tenantReducer?.tenantId) {
      dispatch(
        recommendedProductAction({
          channel: SERVICE_CHANNEL,
          service: serviceType,
          tenantId: tenantReducer.tenantId,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeId, serviceType, tenantReducer?.tenantId, searchMode]);

  /**
   * Method call on window resize
   */
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };

  const removeFocusOfProduct = () => {
    const focussedProduct = document.getElementById(productId);
    if (focussedProduct) {
      focussedProduct.style.border = 'none';
    }
  };

  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);

  return (
    <React.Fragment>
      <div onClick={removeFocusOfProduct} className={!isMobile && 'plp-container plp-au-container grid-container'}>
        <CompactMenuItem
          {...props}
          tenantData={tenantReducer}
          data={prodsData}
          selectedTile={selectedTile}
          filterList={filterList}
          dietaryList={dietaryList}
          sortByList={sortByList}
          filterOptions={filterOptions}
          dietaryOptions={dietaryOptions}
          sortByOptions={sortByOptions}
          handleCheckbox={handleCheckbox}
          handleClearItems={handleClearItems}
          handleRadio={handleRadio}
          handleFilteredData={handleFilteredData}
          handleSearchdata={handleSearchdata}
          tempData={filteredData}
          recommendations={recommendedProds}
          catalogs={catalogs}
          selectedCat={selectedCat}
          triggerGetRecommends={getRecommends}
          storeClosedData={{
            isStoreClosed,
            isStoreNone,
            storeName,
            isModalOpen,
          }}
          setProductId={setProductId}
          specialEventItemAvailability={specialEventItemAvailability}
          isMobile={isMobile}
        />
      </div>

      {userOrderState.addToCart && userOrderState.isLocalized && !userOrderState.fromPdpPage ? (
        <ProductState flatResponse={flatResponse} tenantReducer={tenantReducer} />
      ) : null}
      {cartReducer.showProductListingModal && <ProductListingModalOptions />}
      {userOrderState.cartAlertData?.showCartAlert && <CustomizationAlert />}
    </React.Fragment>
  );
};
